// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3XEjx";
var _4 = "unavailable-s25G2";
var _5 = "unavailableMessage-2NRjm";
var _6 = "passengerName-2IBC-";
var _7 = "notification__root-edx8V";
var _8 = "notification__content-13lbh";
var _9 = "notification__icon-2Spui";
var _a = "personIcon-2kaR4";
var _b = "unavailableMessageIcon-28diX";
var _c = "money-2N5iL";
var _d = "money_unchaned-1BVlu";
var _e = "money_old-1Shv9";
var _f = "header-Zu7Sq";
var _10 = "price-1YpNX";
var _11 = "subisidies-3L4gv";
var _12 = "subsidy-29Em9";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "unavailable", _5 as "unavailableMessage", _6 as "passengerName", _7 as "notification__root", _8 as "notification__content", _9 as "notification__icon", _a as "personIcon", _b as "unavailableMessageIcon", _c as "money", _d as "money_unchaned", _e as "money_old", _f as "header", _10 as "price", _11 as "subisidies", _12 as "subsidy" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "unavailable": _4, "unavailableMessage": _5, "passengerName": _6, "notification__root": _7, "notification__content": _8, "notification__icon": _9, "personIcon": _a, "unavailableMessageIcon": _b, "money": _c, "money_unchaned": _d, "money_old": _e, "header": _f, "price": _10, "subisidies": _11, "subsidy": _12 }
